import React, { useState } from 'react'
import styled from 'styled-components'

const Button = styled.button`
  background: var(--clr-custom-to-accent);
  height: 35px;
  padding: 5px;

  &,
  &:focus,
  &:active {
    border: none;
    outline: none;
  }
`
const toggleTheme = () => {
  const body = document.body
  const isDark = body.classList.contains('dark')
  if (isDark) {
    body.classList.remove('dark')
  } else {
    body.classList.add('dark')
  }
}

const Toggle = () => {
  const [state, setState] = useState(document.getElementById('root').classList.contains('dark'))

  return (
    <Button onClick={() => {
      setState(!state)
      toggleTheme()
    }}>
      { state ? <svg stroke="currentColor" fill="#fff" strokeWidth="0" viewBox="0 0 24 24" color="currentColor" height="1.25rem" width="1.25rem" xmlns="http://www.w3.org/2000/svg"><g><path fill="none" d="M0 0h24v24H0z"></path><path fillRule="nonzero" d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93zM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121zm2.121-14.85l1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121zM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121zM23 11v2h-3v-2h3zM4 11v2H1v-2h3z"></path></g></svg> : null}
      {!state ?
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="currentColor" height="1.25rem" width="1.25rem" xmlns="http://www.w3.org/2000/svg" ><g><path fill="none" d="M0 0h24v24H0z"></path><path fillRule="nonzero" d="M10 6a8 8 0 0 0 11.955 6.956C21.474 18.03 17.2 22 12 22 6.477 22 2 17.523 2 12c0-5.2 3.97-9.474 9.044-9.955A7.963 7.963 0 0 0 10 6zm-6 6a8 8 0 0 0 8 8 8.006 8.006 0 0 0 6.957-4.045c-.316.03-.636.045-.957.045-5.523 0-10-4.477-10-10 0-.321.015-.64.045-.957A8.006 8.006 0 0 0 4 12zm14.164-9.709L19 2.5v1l-.836.209a2 2 0 0 0-1.455 1.455L16.5 6h-1l-.209-.836a2 2 0 0 0-1.455-1.455L13 3.5v-1l.836-.209A2 2 0 0 0 15.29.836L15.5 0h1l.209.836a2 2 0 0 0 1.455 1.455zm5 5L24 7.5v1l-.836.209a2 2 0 0 0-1.455 1.455L21.5 11h-1l-.209-.836a2 2 0 0 0-1.455-1.455L18 8.5v-1l.836-.209a2 2 0 0 0 1.455-1.455L20.5 5h1l.209.836a2 2 0 0 0 1.455 1.455z"></path></g></svg> : null
      }
    </Button>
  )
}

export default Toggle



// WEBPACK FOOTER //
// ./src/components/Toggle/index.js